"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GenericRouter = exports.useHistory = void 0;
var tslib_1 = require("tslib");
var history_1 = require("history");
var react_1 = tslib_1.__importStar(require("react"));
var react_router_dom_1 = require("react-router-dom");
var HistoryContext = (0, react_1.createContext)(undefined);
var useHistory = function () {
    var history = (0, react_1.useContext)(HistoryContext);
    if (!history) {
        throw new Error("HistoryContext is not an ancestor of this component. Did you forget to use GenericRouter component?");
    }
    return history;
};
exports.useHistory = useHistory;
function GenericRouter(_a) {
    var basename = _a.basename, children = _a.children, defaultHistory = _a.history;
    var history = (0, react_1.useMemo)(function () { return defaultHistory || (0, history_1.createBrowserHistory)(); }, [defaultHistory]);
    var _b = tslib_1.__read((0, react_1.useState)({
        action: history.action,
        location: history.location,
    }), 2), state = _b[0], setState = _b[1];
    (0, react_1.useLayoutEffect)(function () { return history.listen(setState); }, [history]);
    return (
    // Remove this HistoryContext when/ if react-router-dom exposes `useHistory` again
    react_1.default.createElement(HistoryContext.Provider, { value: history },
        react_1.default.createElement(react_router_dom_1.Router, { basename: basename, location: state.location, navigationType: state.action, navigator: history }, children)));
}
exports.GenericRouter = GenericRouter;
//# sourceMappingURL=GenericRouter.js.map